/*
 GENERATED FILE - DO NOT MODIFY
 Any changes will be overwritten when `yarn svgs` is executed.
 
 Generated from: assets/close.svg
 If you need to make changes the attributes, modify the original .svg file.
 
 If you need to modify the file further, consider copying this generated file to a new location,
 or into the component that uses it. If you do this, it might make sense to remove the original .svg file, 
 or it could be regenerated the next time SVGs are generated.
*/
import * as React from 'react';
const CloseIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef: any) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M22.111.145c-.343-.186-.7-.176-1.018-.066-.31.107-.592.311-.823.53a556.348 556.348 0 00-8.51 8.304A556.142 556.142 0 003.25.609C3.02.39 2.737.186 2.426.08A1.233 1.233 0 001.41.145C1.188.265.946.441.693.693a3.137 3.137 0 00-.548.716c-.186.343-.176.7-.066 1.017.107.311.311.593.53.823a556.08 556.08 0 008.304 8.51A556.04 556.04 0 00.609 20.27c-.219.23-.423.513-.53.823-.11.318-.12.675.066 1.018.12.221.296.463.548.716.253.252.495.428.716.548.343.186.7.176 1.017.066.311-.107.593-.311.823-.53a556.238 556.238 0 008.511-8.304c4.244 4.22 7.256 7.11 8.51 8.304.23.219.513.422.824.53.317.11.674.12 1.017-.066.221-.12.463-.296.716-.548a3.14 3.14 0 00.548-.716c.186-.343.176-.7.066-1.018-.107-.31-.311-.592-.53-.823a555.713 555.713 0 00-8.304-8.51c4.22-4.244 7.11-7.256 8.304-8.51.219-.23.422-.513.53-.824.11-.317.12-.674-.066-1.017a3.136 3.136 0 00-.549-.716 3.136 3.136 0 00-.715-.548z"
        fill="#165050"
      />
    </svg>
  ),
);
export default CloseIcon;
